
const rgpdConf = {
  loadAds: true,
  loadTracking: true,
  loadCustomization: true,
};

export default rgpdConf;
